import { Component } from '@angular/core';
import {AsyncPipe} from "@angular/common";
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {Router} from '@angular/router';
import { DevelopedForItem, DevelopedForTemplateComponent } from '../developed-for-template/developed-for-template.component';
import {
  DEFAULT_DEVELOPED_FOR_DESCRIPTION,
  DEFAULT_DEVELOPED_FOR_ITEMS,
  DEFAULT_DEVELOPED_FOR_TITLE
} from '../developed-for-template/developed-for-content';
import { MissionTemplateComponent } from '../mission-template/mission-template.component';
import { PlanType, PlansTemplateComponent } from '../plans-template/plans-template.component';
import { TrialTemplateComponent } from '../trial-template/trial-template.component';
import { WhyChooseTemplateComponent } from '../why-choose-template/why-choose-template.component';

@Component({
  selector: 'app-about-us',
  imports: [
    AsyncPipe,
    DevelopedForTemplateComponent,
    MissionTemplateComponent,
    PlansTemplateComponent,
    TrialTemplateComponent,
    WhyChooseTemplateComponent
  ],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.css'
})
export class AboutUsComponent {
  readonly developedForTitle = DEFAULT_DEVELOPED_FOR_TITLE;
  readonly developedForDescription = DEFAULT_DEVELOPED_FOR_DESCRIPTION;
  readonly developedForItems: DevelopedForItem[] = DEFAULT_DEVELOPED_FOR_ITEMS;

  constructor(
    public authService: AuthenticationService,
    private router: Router
  ) {
  }

  async handlePlanSelection(_: PlanType): Promise<void> {
    await this.router.navigate(['/planos']);
  }

  async handleTrialSelection(): Promise<void> {
    await this.router.navigate(['/planos']);
  }
}
